import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "as-match-item__header" }
const _hoisted_3 = { class: "as-match-item__league" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "as-match-item__time as-match-item__status--normal" }
const _hoisted_7 = { class: "as-t_time_num" }
const _hoisted_8 = { class: "as-match-item__date" }
const _hoisted_9 = { class: "as-match-item__body" }
const _hoisted_10 = { class: "as-match-item__team as-match-item__team-home as-team--home" }
const _hoisted_11 = {
  key: 0,
  class: "as-match-item__status"
}
const _hoisted_12 = { class: "as-match-item__team as-match-item__team-away as-team--away" }
const _hoisted_13 = {
  key: 0,
  class: "as-match-item__footer"
}
const _hoisted_14 = {
  key: 0,
  class: "as-commentator"
}
const _hoisted_15 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["xlink:href"]
const _hoisted_19 = ["id", "xlink:href"]
const _hoisted_20 = { class: "as-flag__score-list" }
const _hoisted_21 = { class: "as-flag__team" }
const _hoisted_22 = { class: "as-flag__score-list" }

import { ref, computed, getCurrentInstance } from "vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import OddItem from "~src/modules/home/components/OddItem.vue";
import ProgressBar from "~src/components/matches/ProgressBar.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
import PlayerTennisNew from "~src/components/player/PlayerTennisNew.vue";
import type {
  IMatch,
  IOdd,
  ITeam,
  ILeague,
  ICommentator,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamName } from "~src/helpers/tennis";
import { getOddValue } from "~src/helpers/OddHelper";
import { usecommonStore } from "~src/stores/CommonStore";
import type { IScores } from "~src/interfaces/tennis";
import { getScoresWithKey } from "~src/helpers";
import { convertScores } from "~src/interfaces/tennis";
import MatchEnumVolleyball from "~src/enums/volleyball/MatchEnum";



const __default__ = {};

interface IProps {
  match: IMatch;
  odds?: Array<IOdd>;
  oddsOld?: Array<IOdd>;
  teams: Array<ITeam>;
  commentators: Array<ICommentator>;
  competitions: Array<ILeague> | any;
  isShowFlagHalf: boolean;
  isShowFooter: boolean;
  isH2h: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchItem',
  props: {
    match: {},
    odds: { default: () => [] },
    oddsOld: { default: () => [] },
    teams: {},
    commentators: {},
    competitions: {},
    isShowFlagHalf: { type: Boolean, default: true },
    isShowFooter: { type: Boolean, default: true },
    isH2h: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const commonStore = usecommonStore();
const sportType = computed(() => commonStore.getSportType);

const LIST_STATUS_PLAYING = computed(() => {
  return sportType.value === "volleyball" ? MatchEnumVolleyball.LIST_STATUS_PLAYING : MatchEnum.LIST_STATUS_PLAYING
});
const siteName = computed(() => commonStore.getSiteName);
const odd = computed(() => {
  return props.odds.find((item: IOdd) => item.id === props.match.id);
});

const oddOld = computed(() => {
  return props.oddsOld.find((item: IOdd) => item.id === props.match.id);
});

const isShowOdd = computed(() => {
  let check = false;
  for (const key of [
    "asian_hdp",
    "asian_hdp_home",
    "asian_hdp_away",
    "asian_close",
    "european_home",
    "european_draw",
    "european_away",
    "european_close",
    "over_under_hdp",
    "over",
    "under",
    "over_under_close",
  ] as Array<string>) {
    if (getOddValue(odd.value, oddOld.value, key).value != "") {
      check = true;
    }
    break;
  }

  return check;
});

const competition = computed(() => {
  const compet: any = props.competitions.find(
    (item: ILeague) => item.id === props.match.competition_id
  );

  return compet;
});

const commentator = computed(() => {
  const compet: any = props.commentators.find(
    (item: ICommentator) => item.id === props.match.commentator_id
  );

  return compet;
});

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const matchScores = computed(() => {
  const __scores = getScoresWithKey(convertScores(props.match.scores));
  return __scores;
});

const getMatchTieScores = (scores: any, index: number, mode = 0) => {
  // mode 0: Home
  // mode 1: Away
  const _index = Number(index) + 1;
  const xKey = `x${_index}`;
  const _x = scores[xKey] || ["", ""];

  return _x[mode];
};

const homeScoreTotal = computed(() => {
  return homeScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const awayScoreTotal = computed(() => {
  return awayScores.reduce(
    (partialSum: number, a: number) => partialSum + a,
    0
  );
});

const homeCountryId = computed(() => {
  const _team: any = props.teams.find((team: ITeam) => team.id === props.match.home_team_id);

  if(_team) {
    if( _team.country) {
      return _team.country.id;
    } else if( _team.country_id) {
      return _team.country_id;
    }
  }

  return "default";
});

const awayCountryId = computed(() => {
  const _team: any = props.teams.find((team: ITeam) => team.id === props.match.away_team_id);

  if(_team) {
    if( _team.country) {
      return _team.country.id;
    } else if( _team.country_id) {
      return _team.country_id;
    }
  }

  return "default";
});

const activeIncident = ref(false);
const activeHoverPopup = ref(false);
const activeStatistic = ref("");
let hideTimeout: number | undefined = undefined;

const handleMouseOverPopup = async (event: MouseEvent) => {
  activeHoverPopup.value = true;
};

const handleMouseLeavePopup = async (event: MouseEvent) => {
  activeHoverPopup.value = false;
  activeIncident.value = false;
};

const handleMouseOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "";
};

const handleMouseLeave = () => {
  // Use a timeout to avoid flickering
  setTimeout(() => {
    if (!activeHoverPopup.value) {
      activeIncident.value = false;
    }
  }, 100); // Adjust delay as needed
};

const handleMouseStatisticOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "statistic";
};

const getPT = (scores: IScores, is_away = false) => {
  let score = "";
  if (scores.pt && scores.pt.length) {
    score = scores.pt[0] ?? 0;
    if (is_away) {
      score = scores.pt[1] ?? 0;
    }
  }

  return score === "" ? 0 : score;
};

const getFT = (scores: IScores, is_away = false) => {
  let score = 0;
  if (scores.ft && scores.ft.length) {
    score = Number(scores.ft[0]);
    if (is_away) {
      score = Number(scores.ft[1]);
    }
  }

  return score;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.match.slug,
    title: _ctx.match.title
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["as-match-item", [
        `as-${sportType.value}`,
        {
          'as-is-hot': _ctx.match.is_hot,
          'as-hide-footer': !_ctx.isShowFooter,
          [`as-match-item-${siteName.value}`]: siteName.value,
        },
      ]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (competition.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass(["as-lazy", `as-${sportType.value}`]),
                src: 
              competition.value?.logo ||
              _ctx.getImgUrlBySport('competition', _ctx.match.competition_id)
            ,
                alt: 
              competition.value.short_name ? competition.value.short_name : competition.value.name
            ,
                width: "24px",
                height: "24px"
              }, null, 10, _hoisted_4))
            : _createCommentVNode("", true),
          (competition.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getCompetitionShortCode(competition.value)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (
              (_ctx.isH2h ||
              LIST_STATUS_PLAYING.value.includes(_ctx.match.status_id)) &&
              _ctx.match?.match_time_player
            )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onMouseover: handleMouseStatisticOver,
                onMouseleave: handleMouseLeave,
                class: _normalizeClass(`as-icon-haflt ${
              _ctx.match?.match_time_player.status_h2h
                ? 'as-icon-haflt-' + _ctx.match?.match_time_player.status_h2h
                : ''
            }`)
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.match?.match_time_player?.text), 1)
              ], 34))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatLocalTime)(_ctx.match.match_time, "h:mm DD/MM")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(PlayerTennisNew, {
            team: _ctx.match.home_team,
            match: _ctx.match,
            scores: getPT(_ctx.match.scores),
            country: _ctx.getImgUrlBySport('country', homeCountryId.value),
            modifyClass: "as-w-100 as-h2h as-flex-row-reverse"
          }, null, 8, ["team", "match", "scores", "country"])
        ]),
        (_ctx.match.status_id === _unref(MatchEnum).STATUS_NOT_STARTED)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(`as-score-vs as-score-vs__28 as-score-vs__only-text as-score-vs__only-text-${siteName.value}`)
              }, "vs", 2)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onMouseover: handleMouseOver,
              onMouseleave: handleMouseLeave,
              class: "as-match-item__status"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(`as-score-vs as-score-vs__num as-score-vs__28 as-score-vs-${siteName.value}`)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["as-home-score", {
                'as-winner': getFT(_ctx.match.scores) > getFT(_ctx.match.scores, true),
              }])
                }, _toDisplayString(getFT(_ctx.match.scores)), 3),
                _cache[0] || (_cache[0] = _createElementVNode("b", null, ":", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["as-away-score", {
                'as-winner': getFT(_ctx.match.scores) < getFT(_ctx.match.scores, true),
              }])
                }, _toDisplayString(getFT(_ctx.match.scores, true)), 3)
              ], 2)
            ], 32)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(PlayerTennisNew, {
            team: _ctx.match.away_team,
            match: _ctx.match,
            scores: getPT(_ctx.match.scores),
            country: _ctx.getImgUrlBySport('country', awayCountryId.value),
            modeTeam: "away-team",
            modifyClass: "as-w-100 as-h2h as-flex-row"
          }, null, 8, ["team", "match", "scores", "country"])
        ])
      ]),
      (_ctx.isShowFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.match.commentator_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                    _createElementVNode("path", {
                      d: "M15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681Z",
                      fill: 'url(#pattern_' + _ctx.match.id + ')',
                      stroke: "#FFC107"
                    }, null, 8, _hoisted_16),
                    _cache[1] || (_cache[1] = _createElementVNode("path", {
                      d: "M8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682Z",
                      stroke: "#FFC107"
                    }, null, -1)),
                    _createElementVNode("defs", null, [
                      _createElementVNode("pattern", {
                        id: 'pattern_' + _ctx.match.id,
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1"
                      }, [
                        _createElementVNode("use", {
                          "xlink:href": '#image_' + _ctx.match.commentator_id,
                          transform: "scale(0.000510204)"
                        }, null, 8, _hoisted_18)
                      ], 8, _hoisted_17),
                      _createElementVNode("image", {
                        id: 'image_' + _ctx.match.commentator_id,
                        width: "1960",
                        height: "1960",
                        "xlink:href": commentator.value ? commentator.value.avatar : ''
                      }, null, 8, _hoisted_19)
                    ])
                  ])),
                  _createElementVNode("span", null, _toDisplayString(commentator.value ? commentator.value.name : ""), 1)
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.match.status_id != _unref(MatchEnum).STATUS_NOT_STARTED && _ctx.isShowFlagHalf
          )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(`as-flag as-${sportType.value}`)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`as-flag__team as-${sportType.value}`)
                  }, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.home_team_id)), 3),
                  _createElementVNode("span", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchScores.value['home'], (score, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["as-flag__score", {
                'as-flag__score-win': score > matchScores.value['away'][index],
              }])
                      }, [
                        _createTextVNode(_toDisplayString(score) + " ", 1),
                        (
                  getMatchTieScores(_ctx.match.scores, index, 0) &&
                  Number(getMatchTieScores(_ctx.match.scores, index, 0)) > 0
                )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["is_tie", {
                  'as-bigger':
                    Number(getMatchTieScores(_ctx.match.scores, index, 0)) > 9,
                }])
                            }, _toDisplayString(getMatchTieScores(_ctx.match.scores, index, 0)), 3))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (
            _ctx.match.status_id != _unref(MatchEnum).STATUS_NOT_STARTED && _ctx.isShowFlagHalf
          )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(`as-flag as-${_ctx.gSportType}`)
                }, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(getTeamName)(_ctx.teams, _ctx.match.away_team_id)), 1),
                  _createElementVNode("span", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchScores.value['away'], (score, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["as-flag__score", {
                'as-flag__score-win': score > matchScores.value['home'][index],
              }])
                      }, [
                        _createTextVNode(_toDisplayString(score) + " ", 1),
                        (
                  getMatchTieScores(_ctx.match.scores, index, 1) &&
                  Number(getMatchTieScores(_ctx.match.scores, index, 1)) > 0
                )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["is_tie", {
                  'as-bigger':
                    Number(getMatchTieScores(_ctx.match.scores, index, 1)) > 9,
                }])
                            }, _toDisplayString(getMatchTieScores(_ctx.match.scores, index, 1)), 3))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1))
}
}

})